module.exports = __webpack_public_path__ + "img/zhou2.26401ec6.png";